import { PaymentService } from '@/service/PaymentService'
import { ref } from 'vue'
import { useProductListStore } from '@/store/productListStore'

const loading = ref(false)
export const usePayment = () => {
  const getCurrencyDetails = async () => {
    const productListStore = useProductListStore()
    try {
      loading.value = true
      if (Object.keys(productListStore.currencyDetails).length === 0) {
        const { data } = await PaymentService.getCurrencyDetails()
        if (data && data.currency) {
          productListStore.setCurrencyDetails(data)
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  const fetchPaymentSettings = async (locationId: string) => {
    try {
      loading.value = true
      const { data } = await PaymentService.fetchPaymentSettings(locationId)
      return data
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  return {
    getCurrencyDetails,
    fetchPaymentSettings,
  }
}
